var _rect, _rect2, _rect3, _line, _line2, _line3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApdtUploadBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 33,
    viewBox: "0 0 83 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 82,
    height: 31,
    rx: 15.5,
    fill: "#FAD47F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 82,
    height: 31,
    rx: 15.5,
    stroke: "#FBB040"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.75,
    y: 11.25,
    width: 10.5,
    height: 10.5,
    stroke: "#4E4D4D",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 18.75,
    x2: 29,
    y2: 18.75,
    stroke: "#4E4D4D",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 16.25,
    x2: 29,
    y2: 16.25,
    stroke: "#4E4D4D",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 13.75,
    x2: 29,
    y2: 13.75,
    stroke: "#4E4D4D",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.594 11.742V12.778H42.352V16.068H45.796V17.104H42.352V21.5H41.078V11.742H46.594ZM48.7907 12.582C48.548 12.582 48.3427 12.498 48.1747 12.33C48.0067 12.162 47.9227 11.9567 47.9227 11.714C47.9227 11.4713 48.0067 11.266 48.1747 11.098C48.3427 10.93 48.548 10.846 48.7907 10.846C49.024 10.846 49.22 10.93 49.3787 11.098C49.5467 11.266 49.6307 11.4713 49.6307 11.714C49.6307 11.9567 49.5467 12.162 49.3787 12.33C49.22 12.498 49.024 12.582 48.7907 12.582ZM49.4067 13.828V21.5H48.1327V13.828H49.4067ZM52.852 11.14V21.5H51.578V11.14H52.852ZM62.0233 17.37C62.0233 17.6127 62.0093 17.8693 61.9813 18.14H55.8493C55.896 18.896 56.1526 19.4887 56.6193 19.918C57.0953 20.338 57.6693 20.548 58.3413 20.548C58.892 20.548 59.3493 20.422 59.7133 20.17C60.0866 19.9087 60.348 19.5633 60.4973 19.134H61.8693C61.664 19.8713 61.2533 20.4733 60.6373 20.94C60.0213 21.3973 59.256 21.626 58.3413 21.626C57.6133 21.626 56.96 21.4627 56.3813 21.136C55.812 20.8093 55.364 20.3473 55.0373 19.75C54.7106 19.1433 54.5473 18.4433 54.5473 17.65C54.5473 16.8567 54.706 16.1613 55.0233 15.564C55.3406 14.9667 55.784 14.5093 56.3533 14.192C56.932 13.8653 57.5946 13.702 58.3413 13.702C59.0693 13.702 59.7133 13.8607 60.2733 14.178C60.8333 14.4953 61.2626 14.934 61.5613 15.494C61.8693 16.0447 62.0233 16.67 62.0233 17.37ZM60.7073 17.104C60.7073 16.6187 60.6 16.2033 60.3853 15.858C60.1706 15.5033 59.8766 15.2373 59.5033 15.06C59.1393 14.8733 58.7333 14.78 58.2853 14.78C57.6413 14.78 57.0906 14.9853 56.6333 15.396C56.1853 15.8067 55.9286 16.376 55.8633 17.104H60.7073Z",
    fill: "#4E4D4D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApdtUploadBtn);
export default __webpack_public_path__ + "static/media/apdt_upload_btn.dc9994f1ee629970d3ea9b3904846305.svg";
export { ForwardRef as ReactComponent };